import React from 'react';
import styles from '../Policy & conditions/Term_n_condition.module.css'

const TermsAndConditions = () => {
  return (
    <div className="container-fluid">
    <div className={styles.termsContainer}>
      <h1 className={styles.termsHeader}>Terms and Conditions </h1>
      
      <div className={styles.content}>
        <h2>Welcome and Acceptance</h2>
        <p>
        By accessing and using our Kirana Management Software, you agree to follow the terms and conditions outlined in this agreement. These terms represent a contract between you, the user, and the service provider. If you do not agree with any of the terms, you must refrain from using the software.
The software is provided to assist you in managing your kirana store or general Story, including features for inventory management, billing,Multi-Store Management,Supplier Management and customer data etc. However, by using the service, you acknowledge and accept that it is your responsibility to use it in compliance with the outlined terms. If you fail to adhere to these terms, your access to the software may be suspended or terminated.
Additionally, you are responsible for maintaining the confidentiality of your account credentials and ensuring that unauthorized individuals do not access your account. If any security breach occurs, it must be reported immediately to prevent further damage.
<br /><br />
It’s important to note that the software is provided “as is.” While the service is designed to function reliably, the provider does not guarantee its flawless performance and is not liable for any indirect or consequential damages resulting from its use. The terms of use also cover any legal responsibilities associated with the handling of customer data within the software.
The provider retains the right to modify or update these terms at any time, and users are encouraged to review the terms periodically. Continuing to use the software after any such changes indicates acceptance of the updated terms.
In conclusion, your use of the Kirana Management Software signifies your agreement to these terms and conditions. Ensure you fully understand your responsibilities to avoid any complications.
        </p>
      </div>

      <div className={styles.content}>
        <h2>License Usage</h2>
        <p>
        Our Kirana Management Software, along with its content, is protected under intellectual property laws. By using the software, you are granted a limited, non-transferable license solely for the purpose of managing your kirana store. This license permits you to access and use the software’s features as intended for your business operations.
However, you agree not to reproduce, redistribute, sublicense, or sell any part of the service. Any modification or extraction of the software’s code, data, or content for purposes other than personal, non-commercial use is prohibited. This ensures that the software remains protected from unauthorized use or distribution.
Furthermore, you are prohibited from using any content from the software in a manner that would infringe upon the intellectual property rights of the company. Failure to comply with these terms could result in the termination of your access to the service and potential legal consequences.
By using the software, you acknowledge and accept these terms.
        </p>
      </div>

      <div className={styles.content}>
  <h2>Your Obligations</h2>
  <ul>
    <li>You must always abide by our Terms and Conditions and Policies when using the Kirana Management Software.</li>
    <li>You must provide accurate and complete information while registering your business in the Kirana Management Software app.</li>
    <li>You must not disassemble, decompile, or reverse-engineer the Service, nor assist others in doing so, unless Indian law prohibits such restrictions.</li>
    <li>You must not misuse our Service or engage in any fraudulent or harmful activities with others.</li>
    <li>Our Service is intended solely for users who are 18 years of age or older. By using the Service, you confirm that you are above the age of 18.</li>
    <li>You must represent and warrant that you have the legal right, authority, and capacity to enter into this Agreement and to comply with all the policies outlined in this Agreement.</li>
  </ul>
</div>


      <div className={styles.content}>
        <h2>Cookies</h2>
        <p>
        Our Kirana Management Software uses cookies to enhance your experience on our platform. Cookies are small files stored on your device that help improve the functionality of the service. They allow us to remember your preferences, personalize your user experience, and analyze how you interact with the software. This enables us to deliver more relevant features and improve our service over time.
By using our software, you consent to the use of cookies as outlined in our Privacy Policy. You can manage your cookie preferences through your browser settings, but please note that disabling certain cookies may affect the performance and functionality of the service.
Your continued use of the software indicates that you agree to the collection and use of cookies in accordance with this policy, ensuring a smoother and more efficient experience while using our platform.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Limitation of Liability</h2>
        <p>
        Our software is provided "as is" without any warranty of any kind. We are not responsible for any direct, indirect, incidental, or consequential damages that may arise from your use of the service. Any issues or losses that occur, whether related to data, business operations, or any other aspect, are not the responsibility of the company. By using the service, you acknowledge that you are doing so at your own risk, and we will not be held accountable for any potential negative outcomes.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Modifications</h2>
        <p>
        This section informs users that the service provider holds the right to change or update the terms of service at any time, without prior notice. The modification of terms can occur as needed, and users are encouraged to review these terms periodically. By continuing to use the service after any changes have been made, users implicitly agree to the updated terms. If a user disagrees with the new terms, they should stop using the service immediately. This clause ensures that the provider can adjust the terms as necessary while keeping the user informed of changes.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Security</h2>
        <p>
        We will use industry standard technical and organizational security measures in connection with the storage, processing, and transfer of your Content. These measures are designed to protect the integrity of your data and to guard against unauthorized or unlawful access to, use of, or processing of such data.
<br />
We take every possible step to ensure that your business information remains safe and secure.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Copyright</h2>
        <p>
        All content included on this site and Kirana Management Software app, such as text, graphics, logos, button icons, images, digital downloads, data compilations, and software, is the property of Kirana Management Software or its content suppliers and is protected by international copyright laws. The compilation of all content on this site is the exclusive property of Kirana Management Software, with copyright authorship for this collection by Kirana Management Software, and protected by international copyright laws.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Termination</h2>
        <p>
        You are free to stop using our Kirana Management Software at any time. We also have the right to suspend or terminate the Service at any time if:
(i) You violate our Terms and Policies.
(ii) You are using the Service in a manner that we believe may cause us financial or legal liability.


        </p>
      </div>

      <div className={styles.content}>
        <h2>Your Privacy</h2>
        <p>
        For more details on how we collect, store, and use your personal data, please refer to our Privacy Policy.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Reservation of Rights</h2>
        <p>
        The "Reservation of Rights" clause grants the company the authority to modify or remove any part of the service, including the terms and conditions, without prior notice. Users agree that by continuing to use the service after changes, they accept the updated terms. This clause also allows the company to request the removal of links or content that may violate its policies, and users must comply. The company reserves the right to make changes at its discretion and is not responsible for any issues arising from these modifications.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Hyperlinking to our Content</h2>
        <p>
        The following organizations may link to our website without prior written approval:<br />
        <ul>
        <li>Government agencies.</li>
        <li>Search engines.</li>
        <li>News organizations.</li>
        <li>Online directory distributors.</li>
        <li>Accredited businesses (excluding non-profit organizations).</li></ul>
We may approve other link requests from organizations like consumer information sources, online communities, educational institutions, etc. All links must not mislead, falsely imply sponsorship, or suggest endorsement.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Disclaimer</h2>
        <p>
        The information provided by our Kirana Management Software is for general use and should not be relied upon as a sole source for critical decisions. While we make every effort to ensure that the software is accurate, up-to-date, and functioning properly, we do not guarantee that all features will always be free from errors, interruptions, or inaccuracies. Users are responsible for ensuring that they have backup copies of their data and for taking necessary precautions to protect against potential risks such as loss of data, service interruptions, or other technical issues. We are not liable for any direct, indirect, or consequential damages arising from the use or inability to use the software. The software is provided on an "as-is" basis, and users agree to use it at their own risk. By using this software, users acknowledge and accept this disclaimer.
        </p>
      </div>

      <div className={styles.content}>
        <h2>Notices</h2>
        <p>
        We may provide you with notices related to your account through your registered mobile number or email address. We may also send you marketing or business-related information, including updates or changes to the Service, via your registered mobile number, email address, or on our blog.


        </p>
      </div>
    </div>
     </div>
  );
};

export default TermsAndConditions;
